import { render, staticRenderFns } from "./FormulaHeader.vue?vue&type=template&id=1e92ad18&lang=pug"
import script from "./FormulaHeader.vue?vue&type=script&lang=js"
export * from "./FormulaHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports